export type IconSize = "xs" | "sm" | "md" | "lg" | "xl";

const sizeMap: Record<IconSize, number> = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

export function getIconSize(size: IconSize | number = "md"): number {
  if (typeof size === "number") {
    return size;
  }
  return sizeMap[size];
}
